import {Typography} from "@mui/material";

export const DpInfoContent = () => {



    return {
        title: 'Data Points',
        content: (
            <>
                <Typography paragraph>
                    Data Points are the vocabulary of the system.
                </Typography>

                <ul>
                    <li>
                        They represent the terms, attributes, and metrics
                        that can be assigned to contracts as Contract
                        Data Points.
                    </li>

                    <li>
                        By themselves, Data Points do not contain values,
                        calculations, or business logic.
                    </li>

                    <li>
                        Their Data Type determines what kinds of values
                        can be assigned, such as numbers, percentages,
                        text, dates, or codes.
                    </li>

                    <li>
                        Contract Data Point Values provide the actual
                        values, assumptions, inputs, and calculations
                        associated with a Data Point.
                    </li>

                    <li>
                        Data Point Attributes define how a Data Point
                        behaves throughout the system, including
                        validation, display, and calculation behavior.
                    </li>

                    <li>
                        The same Data Point can be assigned to many
                        different contracts and contract templates.
                    </li>

                    <li>
                        Data Points should be created as reusable
                        business concepts rather than contract-specific
                        values.
                    </li>
                </ul>
            </>
        )
    };


};